/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import {
	Autocomplete as MuiAutocomplete,
	AutocompleteProps,
	createFilterOptions as MuiCreateFilterOptions,
} from '@mui/material'

export const createFilterOptions = MuiCreateFilterOptions

interface PropsType
	extends AutocompleteProps<
		{ label: string; value: string | number },
		boolean | undefined,
		boolean | undefined,
		boolean | undefined
	> {}

export const Autocomplete = (props: PropsType) => {
	return <MuiAutocomplete css={style} {...props} />
}

const style = css({})
